import safeToLowerCase from '../../utils/safeToLowerCase';
import Language from '../lang/language';
import Translation from '../lang/Translation';
import getDeliveryAddress from '../selectors/PlaceOrderSelectors/getDeliveryAddress';
import {getSettings} from '../selectors/selectors';
import Track from '../utils/tracking';
import {setPageMessage} from './pageMessageActions';
import doMetric from '../tracking/bigQueryMetricRecorder';

export default (dispatch, getState) => {
  if (getDeliveryAddress(getState()) && getState().address) {
    const blockAddressSetting = getSettings(getState()).block_address_containing;
    const deliveryAddress = Object.values(getDeliveryAddress(getState())) || [];
    
    if (blockAddressSetting && deliveryAddress.length > 0) {
      const [invalidAddressIdentifier] = Object.keys(blockAddressSetting)
        .filter(invalidString => deliveryAddress
          .some(addressLine => safeToLowerCase(addressLine, true)
            ?.includes(safeToLowerCase(invalidString, true))));
      
      if (invalidAddressIdentifier && blockAddressSetting[invalidAddressIdentifier]
        && Language.doesTranslationExist(blockAddressSetting[invalidAddressIdentifier])) {
        dispatch(setPageMessage(Translation.getText(blockAddressSetting[invalidAddressIdentifier])));
        
        try {
          doMetric(
            'Blocked address',
            [
              {
                name: 'Invalid string in address message',
                value: blockAddressSetting[invalidAddressIdentifier],
              },
            ],
            [
              {
                type: 'Invalid string in address',
                label: invalidAddressIdentifier,
              },
            ],
            'impression',
          );
        } catch (e) {
          Track.error(e);
        }
        
        return true;
      }
    }
  }
  
  return false;
};
